import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import jwt_decode from "jwt-decode";

import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { ROLE_APP } from "constants/actionAccess";
import {
  useActiveRoute,
  useClearRouteOfHub,
  useDeleteRoute,
  useListRoute,
} from "hooks";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Row, Label } from "reactstrap";
import { Switch } from "antd";
import { setListRouteColumn } from "store/actions";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import DetailRoute from "./DetailRoute";
import {
  getInitRouteParams,
  routeModeList,
  routeRecordStatus,
  routeRecordStatusMode,
} from "./utils";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import useUserList from "./useUserList";

const ListRoute = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["route"]);
  const [isLogAdmin, setIsLogAdmin] = useState(false);
  const [isHubAdmin, setIsHubAdmin] = useState(true);
  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);
  const [hubSchedule, setHubSchedule] = useState({
    id: 0,
    isCenter: false,
    name: "",
    isAll: false,
  });
  const { optionUserScan } = useUserList();

  // Detail Route Modal
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // Delete Route Modal
  const [dataDeleteRoute, setDataDeleteRoute] = useState({
    routeId: null,
  });
  const [deleteRouteModal, setDeleteRouteModal] = useState(false);

  // Active Route Modal
  const [dataActiveRoute, setDataActiveRoute] = useState({
    routeId: null,
  });
  const [activeRouteModal, setActiveRouteModal] = useState(false);

  const {
    list: { columnsVisible: routeColumnsVisible },
  } = useSelector(state => state.route);

  // List Route
  const [routeParams, setRouteParams] = useState(() => {
    const initParams = getInitRouteParams();
    return {
      ...initParams,
      columnFilterKeep: {
        "filter[record_status]": "O",
        // "filter[is_new_address]": is_level_2 ? "N" : "O",
      },
      columnFilter: {
        "filter[record_status]": "O",
        // "filter[is_new_address]": is_level_2 ? "N" : "O", // Mặc định 2 cấp
      },
      run: true,
    };
  });

  const {
    isLoading,
    data: routeList,
    refetch: listRoute,
  } = useListRoute({ params: routeParams });

  // Active Route
  const handleActiveRoute = () => {
    listRoute();
  };
  const { mutate: activeRoute } = useActiveRoute(
    handleActiveRoute,
    handleActiveRoute
  );

  // Delete Route
  const handleDeleteRoute = () => {
    listRoute();
  };
  const { mutate: deleteRoute } = useDeleteRoute(
    handleDeleteRoute,
    handleDeleteRoute
  );

  useEffect(() => {
    if (routeParams && routeParams.run) {
      listRoute();
    }
  }, [routeParams]);

  // START Clear route
  const [modalConfirmClear, setModalConfirmClear] = useState(false);
  const toggleConfirmClearModal = () =>
    setModalConfirmClear(!modalConfirmClear);

  const onClearSuccess = () => {
    listRoute();
    toggleConfirmClearModal();
    //
  };
  const { isLoading: isLoadingClear, mutate: mutateClear } =
    useClearRouteOfHub(onClearSuccess);
  // END Clear route

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    // setRouteParams(prev => ({
    //   ...prev,
    //   page: 1,
    //   sizePerPage: 10,
    //   run: true,
    // }));

    initColumn();
  }, [t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (routeList) {
      initColumn();
    }
  }, [routeList]);

  const initColumn = () => {
    if (routeColumnsVisible && Object.keys(routeColumnsVisible).length > 0) {
      initColumns.forEach(item => {
        if (routeColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !routeColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListRouteColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "route") {
          options = routeRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "route") {
          options = routeRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setRouteParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : routeParams.sort,
      columnFilter:
        {
          ...prev.columnFilterKeep,
          ...columnFilter,
        } || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onSearchAllHandle = value => {
    setRouteParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const toggleDeleteRouteModal = () => {
    setDeleteRouteModal(!deleteRouteModal);
  };
  const clickDeleteRouteHandler = (row, index) => {
    setDataDeleteRoute({ routeId: row.id });
    toggleDeleteRouteModal();
  };
  const deleteSingleRouteHandler = () => {
    deleteRoute({
      routeId: dataDeleteRoute.routeId,
    });
    toggleDeleteRouteModal();
  };

  const toggleActiveRouteModal = () => {
    setActiveRouteModal(!activeRouteModal);
  };
  const clickActiveRouteHandler = (row, index) => {
    setDataActiveRoute({ routeId: row.id });
    toggleActiveRouteModal();
  };
  const activeSingleRouteHandler = () => {
    activeRoute({
      routeId: dataActiveRoute.routeId,
      data: {
        record_status: "O",
      },
    });
    toggleActiveRouteModal();
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case routeModeList.EDIT_ROUTE_DETAIL:
        listRoute();
        break;
      default:
        break;
    }
  };

  const clickEditRouteHandler = (row, index) => {
    setDataDetail({ routeId: row.id });
    setMode(routeModeList.EDIT_ROUTE_DETAIL);
    toggleDetailModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ routeId: row.id });
      setMode(routeModeList.VIEW_ROUTE_DETAIL);
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      isShow: isLogAdmin,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.route"),
      onClick: clickEditRouteHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      isShow: isLogAdmin,
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.route"),
      conditionVisible: {
        record_status: [routeRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteRouteHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      isShow: isLogAdmin,
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.route"),
      conditionVisible: {
        record_status: [routeRecordStatusMode.INACTIVE],
      },
      onClick: clickActiveRouteHandler,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "code",
      text: t("table.code"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.code"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "name",
      text: t("table.name"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.name"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "description",
      text: t("table.description"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.description"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    // {
    //   dataField: "phone_number",
    //   text: t("table.phone_number"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.phone_number"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    // {
    //   dataField: "address",
    //   text: t("table.address"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.address"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    // {
    //   dataField: "ward_code",
    //   text: t("table.ward_code"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.ward_code"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    // {
    //   dataField: "district_code",
    //   text: t("table.district_code"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.district_code"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    // {
    //   dataField: "province_code",
    //   text: t("table.province_code"),
    //   filter: textFilter({
    //     delay: DELAY_FILTER_TIME,
    //     placeholder: t("placeholder.enter", {
    //       title: t("table.province_code"),
    //     }),
    //   }),
    //   sort: true,
    //   allowExport: true,
    // },
    {
      dataField: "hub_id",
      text: "Center/Hub",
      sort: true,
      formatter: (cell, row) => {
        return row?.hub?.name;
      },
    },
    {
      dataField: "record_status",
      text: t("table.record_status.route.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.route.name"),
        }),
        options: selectOptionsTable(undefined, "record_status", "route"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && routeRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "route");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={routeParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={routeParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : "";
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={routeParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
  ];

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const listRole = info["auth"].split(",");
    setIsHubAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_HUB_ADMIN))
        ? true
        : false || false
    );
    setIsLogAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_LOG_ADMIN))
        ? true
        : false || false
    );
  }, []);

  const handleSelectHub = (_idsFilter, isSelectAll, hub) => {
    setHubSchedule({
      id: hub?.id || 0,
      isCenter: hub?.is_center,
      name: hub?.name,
      isAll: isSelectAll,
    });
  };

  const handleClearSchedule = async () => {
    if (hubSchedule?.id) {
      mutateClear({ hub_id: hubSchedule.id });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${routeList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Route Modal */}
              <DetailRoute
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
              />
              {/* Delete Route Modal */}
              <ConfirmModal
                isOpen={deleteRouteModal}
                titleHeader={t("form.submit.delete.route.confirm.header")}
                titleBody={t("form.submit.delete.route.confirm.body")}
                onConfirm={deleteSingleRouteHandler}
                textBtnConfirm={t("form.submit.delete.route.confirm.agree")}
                textBtnCancel={t("form.submit.delete.route.confirm.cancel")}
                toggle={toggleDeleteRouteModal}
              />
              {/* Active Route Modal */}
              <ConfirmModal
                isOpen={activeRouteModal}
                titleHeader={t("form.submit.active.route.confirm.header")}
                titleBody={t("form.submit.active.route.confirm.body")}
                onConfirm={activeSingleRouteHandler}
                textBtnConfirm={t("form.submit.active.route.confirm.agree")}
                textBtnCancel={t("form.submit.active.route.confirm.cancel")}
                toggle={toggleActiveRouteModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* Clear Modal */}
                  <ConfirmModal
                    isOpen={modalConfirmClear}
                    titleHeader={
                      <>
                        Xác nhận clear phân bổ tuyến vận chuyển:{" "}
                        <span className="text-danger">
                          {hubSchedule?.isCenter ? "Center" : "Hub"}{" "}
                          {hubSchedule?.name}
                        </span>
                      </>
                    }
                    titleBody={
                      "Hệ thống sẽ thực hiện clear phân bổ tuyến vận chuyển ?"
                    }
                    isDisableButton={isLoadingClear}
                    onConfirm={handleClearSchedule}
                    textBtnConfirm={"Xác nhận"}
                    textBtnCancel={"Đóng"}
                    toggle={toggleConfirmClearModal}
                  />
                  <RemoteDataTable
                    keyField="id"
                    data={routeList?.items || []}
                    columns={columnsTable}
                    page={routeParams.page}
                    sizePerPage={routeParams.sizePerPage}
                    totalSize={routeList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <HubFilter
                        mainFilterParams={routeParams}
                        setMainFilterParams={setRouteParams}
                        isNotFilterChildHub={true}
                        isHaveAllOption={true}
                        isFilterAllDefault={true}
                        handleSelectHub={handleSelectHub}
                        addressLevel={3}
                      />
                      {isLogAdmin && (
                        <>
                          <Link
                            to="/route/create"
                            className="btn btn-primary btn-label"
                          >
                            <i className="fas fa-plus label-icon" />
                            {t("title.create")}
                          </Link>
                          <Button
                            onClick={() => {
                              toggleConfirmClearModal();
                            }}
                            color="danger"
                            className="btn-label"
                            type="button"
                            disabled={!hubSchedule.id || hubSchedule.isAll}
                          >
                            <i className="bx bxs-trash me-2 label-icon" />
                            Clear phân bổ tuyến vận chuyển
                          </Button>
                        </>
                      )}
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListRoute;
